export default __webpack_public_path__ + "static/media/icon-avatar-club.8c3b146d.svg";